// noinspection JSUnusedGlobalSymbols
import { createRoot } from 'react-dom/client';
import { createElement } from '@wordpress/element';
import Dashboard from './src/index';
import './src/scss/style.scss';
window.addEventListener('load', function () {
    var data = document.querySelector('.slideverse-admin-page');
    if (data) {
        createRoot(data).render(createElement(Dashboard));
    }
});
